import { PATTERN_CNPJ } from './shared/constants';
import applyNumberMask from './shared/apply-number-mask';

export default function cnpj(value) {
  const pattern = PATTERN_CNPJ;
  return applyNumberMask({ value, pattern });
}
